const AboutPage = () => {
  return (
    <div
      className="min-h-screen px-8 md:px-16 py-12 mt-[10vh] animate-fadeIn bg-[#F0F0F0] z-30 relative pt-[10vh]"
      style={{ backgroundImage: "url('/bg-contact.jpg')" }}
    >
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-[10vh] items-center">
        {/* Left Side: Heading & Signature */}
        <div className="relative">
          {/* Heading */}
          <h1 className="text-4xl md:text-5xl lg:text-7xl text-[#111010] font-extrabold leading-tight relative z-[50]">
            <span className="text-[#ae0c00]">W</span>HO ARE WE? AND{" "}
            <span className="text-[#ae0c00]">W</span>HY CHOOSE US
          </h1>
        </div>

        {/* Right Side: Image */}
        <div className="w-full relative lg:absolute lg:right-0 lg:top-16 z-0 md:w-2/3 lg:w-2/3 p-5 lg:p-10">
          <img
            src="/2.jpg"
            alt="Torne Hope"
            className="rounded-lg shadow-lg object-cover w-full h-auto lg:w-full"
          />
        </div>
      </div>

      {/* Description Section */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mt-10">
        {/* Left Side: Description */}
        <div className="text-left">
          <p className="text-lg text-gray-600 w-full md:w-3/4 lg:w-2/3">
            Pals Infotech is a forward-thinking IT company specializing in
            delivering innovative technology solutions tailored to modern
            business needs. With expertise in software development, web design,
            and IT consulting, they empower businesses to thrive in the digital
            era.
          </p>

          <p className="mt-4 text-lg text-gray-600 w-full md:w-3/4 lg:w-2/3">
            Their dedicated team focuses on creating scalable, secure, and
            user-centric solutions. Pals Infotech values customer satisfaction,
            providing personalized support and cutting-edge technologies.
            Committed to excellence, they help businesses achieve their digital
            transformation goals efficiently.
          </p>
        </div>

        {/* Right Side: Optional Testimonial or Content */}
        <div className="hidden lg:block">
          {/* You can add testimonial or any other content here */}
        </div>
      </div>

      {/* Social Links Section (Optional) */}
    </div>
  );
};

export default AboutPage;
